import { CopyrightComponent } from './copyright/copyright.component';
import { FooterComponent } from './footer/footer.component';
import { SubFooterComponent } from './subfooter/subfooter.component';

export const Components = [
	CopyrightComponent,
	FooterComponent,
	SubFooterComponent,
];
